import styled from 'styled-components';

import { color, variable } from '../../helpers/style.helpers';
import { DropdownOptions } from '../ListItem/ListItem.decl';

import {
  Dropdown,
  Flex,
  IconButton,
  Menu,
  MenuItem,
  MenuVerticalFilled,
  useTheme,
} from '@aircall/tractor';

const IconWrapper = styled(Flex)`
  align-items: center;
  justify-content: center;
  padding: ${variable.space.xxs}px;
  border-radius: 50%;
  transition: all 0.25s ease-in-out;
`;

const TableDropdownWrapper = styled(Flex)`
  padding: ${variable.space.xxxs}px;
  border-left: 1px solid ${color.grey.light};
  margin: -${variable.space.s}px;
  cursor: pointer;

  &:hover {
    > ${IconWrapper} {
      background-color: ${color.grey.light};
    }
  }
`;

interface TableDropdownProps {
  options: DropdownOptions[];
  'data-test'?: string;
}

export function TableDropdown({
  options,
  'data-test': dataTest = 'table-dropdown',
}: TableDropdownProps) {
  const { space } = useTheme();

  return (
    <Dropdown
      trigger={
        <TableDropdownWrapper>
          <IconWrapper>
            <IconButton
              size={space.s}
              component={MenuVerticalFilled}
              color='grey.dark'
              data-test={`${dataTest}-trigger`}
              discColor='transparent'
            />
          </IconWrapper>
        </TableDropdownWrapper>
      }
      position='bottom'
      anchor='start'
    >
      <Menu>
        {options.map(({ title, callback }, index) => (
          <MenuItem key={title} onClick={callback} data-test={`${dataTest}-menu-item-${index}`}>
            {title}
          </MenuItem>
        ))}
      </Menu>
    </Dropdown>
  );
}
